// The monthly budget, and the campaigns the seller has put off limits.
//
// A campaign marked for growth is never trimmed and never a donor: the seller
// has decided it matters more than its current numbers say, and a tool that
// overrides that is a tool they switch off.
import React, { useState } from 'react';
import s from '../BudgetOptimiser.module.css';
import { money } from '../format';

export default function Settings({ settings, plan, onSave, busy, currency }) {
  const [budget, setBudget] = useState('');
  if (!settings) return <p className={s.empty}>Loading…</p>;
  const current = settings.monthly_budget;

  return (
    <div>
      <h3 className={s.sectionTitle}>Your monthly ad budget</h3>
      <p className={s.coverage}>
        {settings.note} Set it once and the plan keeps the month inside it with small,
        early changes rather than a cut at the end.
      </p>
      <div className={s.discoverBar}>
        <label className={s.field}>
          <span className={s.label}>
            {current ? `Currently ${money(current, currency)}` : 'Not set yet'}
          </span>
          <input className={s.monthInput} value={budget} inputMode="numeric"
                 placeholder={current ? String(current) : 'e.g. 60000'}
                 onChange={(e) => setBudget(e.target.value.replace(/[^0-9]/g, ''))} />
        </label>
        <button className={s.button} disabled={busy || !budget}
                onClick={() => { onSave({ monthly_budget: Number(budget) });
                                 setBudget(''); }}>
          Save
        </button>
      </div>

      <h3 className={s.sectionTitle}>How you would rather it worked</h3>
      <label className={s.field} style={{ flexDirection: 'row', gap: 8,
                                          alignItems: 'center' }}>
        <input type="checkbox" checked={!!settings.prefer_no_extra_spend}
               disabled={busy}
               onChange={(e) => onSave({ prefer_no_extra_spend: e.target.checked })} />
        <span>Do not offer to increase my total spend — move money instead</span>
      </label>
      <label className={s.field} style={{ flexDirection: 'row', gap: 8,
                                          alignItems: 'center', marginTop: 8 }}>
        <input type="checkbox" checked={!!settings.portfolio_hard_stop}
               disabled={busy}
               onChange={(e) => onSave({ portfolio_hard_stop: e.target.checked })} />
        <span>Use Amazon's own monthly portfolio cap as a hard stop</span>
      </label>
      <p className={s.coverage}>{settings.portfolio_cap_note}</p>

      {!!(plan?.classification) && (
        <>
          <h3 className={s.sectionTitle}>Campaigns off limits</h3>
          <p className={s.coverage}>
            A campaign marked for growth is never trimmed and never has money taken out
            of it.
          </p>
          <div className={s.tableWrap}>
            <table className={s.table}>
              <thead>
                <tr><th>Campaign</th><th>Where it stands</th><th>For growth</th></tr>
              </thead>
              <tbody>
                {Object.entries(plan.classification).map(([id, verdict]) => (
                  <tr key={id}>
                    <td>{verdict.name || id}</td>
                    <td className={s.thin} title={verdict.why}>{verdict.state}</td>
                    <td>
                      <input type="checkbox" disabled={busy}
                             checked={(settings.growth_marked || []).includes(id)}
                             onChange={(e) => {
                               const marked = new Set(settings.growth_marked || []);
                               if (e.target.checked) marked.add(id);
                               else marked.delete(id);
                               onSave({ growth_marked: Array.from(marked) });
                             }} />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}

      {plan?.rollover && <p className={s.coverage}>{plan.rollover.note}</p>}
      {plan?.usage_note && <p className={s.coverageWarn}>{plan.usage_note}</p>}
    </div>
  );
}
